import { Injectable, OnDestroy } from '@angular/core';
import { AbstractCRUDService } from '@campaign-portal/components-library';
import { EntityField, InputComplexType, InputType } from '@campaign-portal/namespace/common/entityField';
import { FilterType } from '@campaign-portal/namespace/common/rpc.params';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { ReadResponse } from '@campaign-portal/namespace/common/implementations';
import { eapiEnable } from '../../app.module';

@Injectable({
	providedIn: 'root'
})
export class ClientsFieldsService implements AbstractCRUDService, OnDestroy {

	readonly name: EntityField = {
		id: 0,
		name: 'clients.name',
		variable: 'name',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT
	};
	readonly productIds: EntityField = {
		id: 1,
		name: 'clients.client_product',
		variable: 'productIds',
		filterType: FilterType.LIKE,
		required: false,
		type: InputComplexType.MULTISELECT,
		data: []
	};
	readonly availableInterfaces: EntityField = {
		id: 2,
		name: 'clients.available_interfaces',
		variable: 'availableInterfaces',
		filterType: FilterType.LIKE,
		required: false,
		type: InputComplexType.MULTISELECT,
		data: ['http', 'enum', 'smsrt']
	};
	readonly maxSessionsAmount: EntityField = {
		id: 3,
		name: 'clients.max_sessions',
		variable: 'maxSessionsAmount',
		filterType: FilterType.BETWEEN,
		required: false,
		type: InputComplexType.RANGE,
		data: []
	};

	readonly entity = '';
	readonly title = '';
	readonly loading$ = new BehaviorSubject<boolean>(false);
	readonly headers: EntityField[] = [
		this.name,
		this.productIds,
		this.availableInterfaces,
		this.maxSessionsAmount
	];

	constructor() {
	}

	ngOnDestroy(): void {
		this.loading$.complete();
	}

	read(): Observable<ReadResponse<EntityField[]>> {
		if (!eapiEnable) {
			this.productIds.type = InputType.TEXT;
		}
		return of({
			Success: true,
			Total: this.headers.length,
			Data: this.headers
		});

	}

	create(): Observable<void> {
		return of();
	}

	update(): Observable<void> {
		return of();
	}

	delete(): Observable<void> {
		return of();
	}
}